import React, { useEffect, useState } from "react";
import { Form, Card, Row, Col, Offcanvas, Badge, ProgressBar, Container } from "react-bootstrap";
import { CiSearch } from "react-icons/ci";
import { useParams } from "react-router-dom";
import { studyOtherSettingsServices } from "../../../../APIServices/studyOtherSettingsServices";
import { NoDataFoundTable, PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";
import { eiwrsDepotManagementServices } from "../../../../APIServices/EIWRS/eiwrsDepotManagementServices";
import { studyOnboardingService } from "../../../../APIServices/studyOnboarding";
import SplitPane from "react-split-pane";
import Swal from "sweetalert2";
import DepotProperties from "../DepotProperties/DepotProperties";
import UpdateDepot from "./UpdateDepot";
import DeletedDepot from "./DeletedDepot";
import DepotUpdatedHistory from "../DepotProperties/DepotUpdatedHistory";
import DepotActivities from "../DepotProperties/DepotActivities";
import UseToggle from "../../../../Hooks/UseToggle";
import AddDepotForm from "./AddDepotForm";
import Pagination from "../../../Pagination";
import ManageDepotOrder from "./ManageDepotOrder";
import { usersOnboardingService } from "../../../../APIServices/usersOnboarding";
import { FaBox, FaBoxOpen, FaBuilding, FaEnvelope, FaExclamationTriangle, FaMapMarkerAlt, FaPhone, FaWarehouse } from "react-icons/fa";
import DepotDetail from "./DepotDetail";
import { FaRegHospital } from "react-icons/fa6";
import { eiwrsKitPreparationServices } from "../../../../APIServices/EIWRS/KitManagement/eiwrsKitPreparationServices";
import { handleResponse } from "../../../../APIHelpers/Responses";

const DepotDataList = ({ onMouseDown, tableRef }) => {
  const [searchData, setSearchData] = useState("");
  const [rowId, setRowId] = useState("");
  const [rowData, setRowData] = useState("");
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [historyLoader, setHistoryLoader] = useState(false);
  const [activityLoader, setActivityLoader] = useState(false);
  const [downloadLoader, setDownloadLoader] = useState(false);
  const [activeTab, setActiveTab] = useState("properties");
  const [depotColumns, setDepotColumns] = useState([]);
  const [depotColumnsCount, setDepotColumnsCount] = useState(0);
  const [tableColumns, setTableColumns] = useState({});
  const [depotHistory, setDepotHistory] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [depotRows, setDepotRows] = useState([]);
  const [depotRowsCount, setDepotRowsCount] = useState(0);
  const [depotDeletedRows, setDepotDeletedRows] = useState([]);
  const [depotDeletedRowsCount, setDepotDeletedRowsCount] = useState(0);
  const [depotActivity, setDepotActivity] = useState([]);
  const [depotActivityCount, setDepotActivityCount] = useState(0);
  const [totalKit, setTotalKit] = useState(0);
  const [totalAvailableKit, setTotalAvailableKit] = useState(0);
  const {
    toggle, setToggle,
    toggle1, setToggle1,
    toggle2, setToggle2,
    toggle3, setToggle3,
    toggle4, setToggle4,
    toggle5, setToggle5,
    toggle6, setToggle6,
    toggle7, setToggle7,
  } = UseToggle();
  const [loading, setLoading] = useState(false);
  let { studyId } = useParams();
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);

  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const ctmsPermission = JSON.parse(localStorage.getItem("ctmsPermissionData"));
  const eiwrsPermission = JSON.parse(localStorage.getItem("studyPermissionData"));

  const toggleFullScreen = () => {
    setIsFullScreen(!isFullScreen);
  };

  const getStudyDepotColumnData = async (e) => {
    setLoading(true);
    let data = await eiwrsDepotManagementServices.getStudyDepotColumnData(
      "active",
      studyId
    );
    setDepotColumns(data?.data || []);
    setDepotColumnsCount(data?.count || 0);
    setLoading(false);
  };

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(depotRowsCount / itemsPerPage);



  const getStudyDepotRowData = async (e) => {
    setLoading(true);
    let data = await eiwrsDepotManagementServices.getStudyDepotRowData(
      "active",
      studyId,
      StudyMode,
      searchData,
      pageNumber,
      itemsPerPage
    );
    setDepotRows(data?.data || []);
    setDepotRowsCount(data?.count || 0);
    setTotalKit(data?.totalKit || 0);
    setTotalAvailableKit(data?.totalAvailableKit || 0);
    setRowData("");
    setRowId("");
    setLoading(false);
  };

  const [pageNumberDeleted, setPageNumberDeleted] = useState(1);
  const [itemsPerPageDeleted, setItemsPerPageDeleted] = useState(10);

  const getDeletedStudyDepotRowData = async (
    pageNumberDeleted,
    itemsPerPageDeleted
  ) => {
    let data = await eiwrsDepotManagementServices.getStudyDepotRowData(
      "deleted",
      studyId,
      "",
      pageNumberDeleted,
      itemsPerPageDeleted
    );
    setDepotDeletedRows(data?.data || []);
    setDepotDeletedRowsCount(data?.count || 0);
  };

  const getStudyDepotAutitTrials = async (e) => {
    setHistoryLoader(true);
    let data = await eiwrsDepotManagementServices.getStudyDepotAuditTrials(
      studyId,
      rowData?.depotId
    );
    setDepotHistory(data?.data || []);
    setHistoryLoader(false);
  };

  const getStudyAuditTrials = async (pageNumber, itemsPerPage) => {
    setActivityLoader(true);
    let data = await studyOnboardingService.getStudyAuditTrials(
      "depotData",
      studyId,
      rowData?.depotId,
      StudyMode,
      pageNumber,
      itemsPerPage
    );
    setDepotActivity(data?.data || []);
    setDepotActivityCount(data?.count || 0);
    setActivityLoader(false);
  };

  const getCountries = async (e) => {
    let data = await usersOnboardingService.getCountries(e);
    setCountryList(data);
  };

  const getStudyKitInventory = async (depotId) => {
    setDownloadLoader(true)
    let data = await eiwrsKitPreparationServices.getStudyKitInventory(studyId, "active", StudyMode);
    if (depotId) {
      let result = (data?.data || [])?.filter(item => (item.depotId === depotId && item?.status === "available"))
      downloadCSV(result);
    } else {
      let result = (data?.data || [])?.filter(item => item?.status === "available")
      downloadCSV(result);
    }
    setDownloadLoader(false)
  };

  const downloadCSV = (data) => {
    if (data.length === 0) {
      handleResponse({
        statusCode: 400,
        customMessage: "Kit not found"
      })
    }
    if (!data || !data.length) return;
    const headers = [
      "Sr.",
      "Depot",
      "Kit Number",
      "Kit Type",
      "Batch Number",
      "Treatment",
      "Expiry DT",
      "Status",
    ];
    const rows = data.map((kitData, index) => [
      index + 1,
      kitData.depot,
      kitData.kitNumber,
      kitData.kitType,
      kitData.batchNumber,
      (eiwrsPermission?.liveTreatmentUnblinded || eiwrsPermission?.qcTreatmentUnblinded || eiwrsPermission?.dbpTreatmentUnblinded) ? kitData.treatment || "_" : "Blinded",
      kitData.expiryDate,
      kitData?.quarantined ? "quarantined" : kitData?.status === "inPreparation" ? "In Preparation" : kitData?.status === "pendingQC" ? "Pending QC" : kitData?.status === "failedQC" ? "Failed QC" : kitData?.status === "available" ? "Available at Depot" : kitData?.status === "allocated" ? "Allocated at Site" : kitData?.status === "passedQC" ? "Passed QC" : kitData?.status,
    ]);
    const csvContent = [headers, ...rows]
      .map(row => row.map(val => `"${val}"`).join(","))
      .join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = "Depot_Kit_Inventory.csv";
    link.click();
    URL.revokeObjectURL(url);
  };

  useEffect(() => {
    getStudyDepotColumnData();
    getCountries()
  }, []);

  useEffect(() => {
    getStudyDepotRowData();
  }, [searchData, pageNumber, itemsPerPage]);

  const softDeleteRestoreStudyDepotRow = async (id, type) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${type} depot!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${type} it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.id = id;
        userData.studyId = studyId;
        userData.type = type;
        let data = await eiwrsDepotManagementServices.softDeleteRestoreStudyDepotRow(userData);
        if (data?.statusCode === 200) {
          getStudyDepotRowData();
          getDeletedStudyDepotRowData();
          setRowId("");
          if (type === "restore") {
            getDeletedStudyDepotRowData(pageNumberDeleted, itemsPerPageDeleted);
            setToggle1();
          }
        }
      }
    });
  };

  const getVisibleColumns = () => {
    return depotColumns?.filter(col => !tableColumns[col?.columnName]) || [];
  };

  const renderValue = (row, column) => {
    const value = row?.row[column?.columnName];
    if (!value) return "—";
    return value;
  };

  const handleTabClick = (tab, row, fetchData = false) => {
    setRowData(row);
    setRowId(row?._id);
    setActiveTab(tab);
    if (tab === "updated History" && fetchData) {
      getStudyDepotAutitTrials();
    } else if (tab === "Depot Activities" && fetchData) {
      getStudyAuditTrials(1, 10);
    }
  };

  const overviewCards = [
    {
      title: "Total Depots",
      value: depotRowsCount,
      subtitle: "Total depots configured in the study",
      icon: <FaRegHospital className="bg-white text-primary shadow-sm" />,
    },
    {
      title: "Total Kits",
      value: totalKit,
      subtitle: "Total kits available across all depots",
      icon: <FaBoxOpen className="bg-white text-info shadow-sm" />,
    },
    {
      title: "Available Kit",
      value: totalAvailableKit,
      subtitle: "Kits currently available for allocation",
      icon: <FaBox className="bg-white text-success shadow-sm" />,
    }
  ];

  return (
    <>
      <div className="justify-content-between toolbar border-bottom hstack p-1" style={{ height: 36 }}>
        <div className="hstack gap-1">
          {StudyMode === "DBP Mode" &&
            <>
              <i
                title={isFormOpen ? "Close Form" : "Add New Depot"}
                onClick={() => {
                  setIsFormOpen(!isFormOpen);
                  setRowId("");
                }}
                className={`fa-solid ${isFormOpen ? "fa-table-list" : "fa-plus-square CP"}`}
              />
              <div className="vr"></div>
            </>
          }
          {depotRowsCount > 0 && (
            <div className="position-relative">
              <Form.Control
                type="Search"
                onChange={(e) => setSearchData(e.target.value)}
                value={searchData}
                placeholder="Search..."
                style={{ width: 200, padding: "3px 10px" }}
              />
              <CiSearch
                className="CP position-absolute bg-white"
                title="Search"
                style={{ width: 15, top: 4, right: 7 }}
              />
            </div>
          )}
        </div>
        <div className="hstack gap-2">
          <button
            className="updateProfile"
            style={{ fontSize: 12 }}
            disabled={downloadLoader}
            onClick={(e) => getStudyKitInventory()}
          >
            Download CSV
          </button>
          {StudyMode === "DBP Mode" &&
            <>
              {(ctmsPermission?.manageOrder && depotRowsCount > 0) && (
                <>
                  <button
                    onClick={() => {
                      setToggle6();
                    }}
                    className="updateProfile"
                    style={{ fontSize: 12 }}
                  >
                    Manage Order
                  </button>
                </>
              )}
              {depotDeletedRowsCount > 0 && (
                <button
                  onClick={() => {
                    setToggle1();
                    getDeletedStudyDepotRowData(pageNumberDeleted, itemsPerPageDeleted);
                  }}
                  className="updateProfile"
                >
                  Deleted History
                </button>
              )}
            </>
          }
        </div>
      </div>
      <SplitPane
        split="vertical"
        minSize={20}
        className="position-relative"
        style={{ height: "calc(100vh - 182px)" }}
        defaultSize={isFormOpen ? "20%" : "100%"}
      >
        {isFormOpen && (
          <AddDepotForm
            getStudyDepotRowData={getStudyDepotRowData}
            countryList={countryList}
          />
        )}
        <>
          <Container fluid>
            <Row className="g-2">
              {overviewCards?.map((item, index) => (
                <Col xl={4} lg={4} md={6} sm={12} key={index} className="mb-2 pt-2">
                  <Card className="app-card bg-light border h-100">
                    <Card.Body>
                      <div className="d-flex gap-3">
                        <div className="study_icopn">
                          {item.icon}
                        </div>
                        <div>
                          <Card.Title style={{ fontSize: 16 }}>{item.title}</Card.Title>
                          <Card.Text className="m-0">{item.value || "0"}</Card.Text>
                          <Card.Text style={{ fontSize: 11 }}>{item.subtitle}</Card.Text>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </Container>
          {loading ? (
            <PageLoader />
          ) : depotRowsCount === 0 ? (
            <NoDataFoundTable MSG={"Depot Data not found!"} />
          ) : depotRows?.length === 0 ? (
            <NoDataFoundTable MSG={"Search Depot Data not found!"} />
          ) : (
            <>
              <Container fluid>
                <Row className="g-2">
                  {depotRows?.map((row, index) => {
                    const visibleColumns = getVisibleColumns();
                    return (
                      <Col key={row._id} xs={12} md={6} xl={4} className="mb-2">
                        <Card className="app-card h-100 shadow-sm border-0">
                          <Card.Body>
                            <div className="d-flex justify-content-between align-items-start mb-3">
                              <div>
                                <h6 className="fw-bold mb-1">
                                  {row?.row?.DEPOTNAME}
                                </h6>
                                <div className="text-muted small">
                                  {row?.row?.DEPOTID}
                                </div>
                              </div>
                              <div className="d-flex gap-1">
                                <Badge
                                  bg="success-subtle"
                                  style={{ padding: "1px 10px" }}
                                  className={`br3 text-success px-2 py-1 text-capitalize`}
                                >
                                  Active
                                </Badge>
                                <button
                                  className="updateProfile"
                                  style={{ padding: "1px 10px" }}
                                  onClick={(e) => {
                                    if (!downloadLoader) {
                                      getStudyKitInventory(row?.depotId)
                                    }
                                  }}
                                >
                                  Download CSV
                                </button>
                                <button
                                  className="updateProfile"
                                  style={{ padding: "1px 10px" }}
                                  onClick={() => {
                                    setRowData(row);
                                    setToggle7();
                                  }}
                                >
                                  View
                                </button>
                              </div>
                            </div>
                            <div className="mb-2">
                              <div className="d-flex align-items-center gap-2 text-muted small">
                                <FaMapMarkerAlt size={12} />
                                <span>{row?.row?.DEPOTID}</span>
                                <span className="text-muted">•</span>
                                <FaBuilding size={12} />
                                <span>{row?.row?.ADDRESS}</span>
                              </div>
                              <div className="d-flex align-items-center gap-2 text-muted small mt-1">
                                <FaEnvelope size={12} />
                                <span>{row?.row?.CONTACTEMAIL}</span>
                                <span className="text-muted">•</span>
                                <FaPhone size={12} />
                                <span>{row?.row?.CONTACTPHONE}</span>
                              </div>
                            </div>

                            <hr className="my-2" />

                            {/* Stock Information */}
                            <div className="mb-2">
                              <div className="d-flex justify-content-between small">
                                <span className="text-muted">Stock Level</span>
                                <span className="fw-semibold">
                                  {row?.usedKit} / {row?.totalKit}
                                </span>
                              </div>
                              <ProgressBar
                                now={row?.kitProgress}
                                variant={row?.kitProgress > 90 ? "danger" : row?.kitProgress > 80 ? "warning" : "success"}
                                style={{ height: 6 }}
                                className="mt-1"
                              />
                              <div className="d-flex justify-content-between small mt-1">
                                <span className="text-muted">{row?.kitProgress}% utilized</span>
                                {row?.kitProgress > 90 &&
                                  <span style={{ fontSize: 10 }} className="text-danger">
                                    <FaExclamationTriangle size={10} className="me-1" />
                                    {row?.kitProgress === 100 ? "Finished Stock" : "Low Stock"}
                                  </span>
                                }
                              </div>
                            </div>
                            {((eiwrsPermission?.liveTreatmentUnblinded || eiwrsPermission?.qcTreatmentUnblinded || eiwrsPermission?.dbpTreatmentUnblinded) && (row?.treatmentList || [])?.length > 0) &&
                              <div className="mb-2">
                                {(row?.treatmentList || [])?.map((treat, key) => (
                                  <div className="d-flex justify-content-between align-items-center small py-1 border-bottom border-light">
                                    <span className="text-muted">{treat?.treatment}</span>
                                    <span className="fw-semibold">
                                      {treat?.usedKit} / {treat?.totalKit}
                                    </span>
                                  </div>
                                ))}
                              </div>
                            }
                            <hr className="my-2" />
                            <div className="hstack justify-content-between small">
                              <div style={{ fontSize: 13 }} className="fw-bold">Total Shipment</div>
                              <span className="text-muted">{row?.totalShipment}</span>
                            </div>
                          </Card.Body>
                          <Card.Footer className="bg-white border-top">
                            <div className="hstack gap-2 justify-content-between flex-wrap">
                              <button
                                className="updateProfile"
                                style={{ padding: "1px 10px" }}
                                onClick={() => {
                                  handleTabClick("properties", row);
                                  setToggle5();
                                }}
                              >
                                Properties
                              </button>
                              <button
                                className="updateProfile"
                                style={{ padding: "1px 10px" }}
                                onClick={() => {
                                  handleTabClick(
                                    "updated History",
                                    row,
                                    true
                                  );
                                  setToggle4();
                                }}
                              >
                                Updated History
                              </button>
                              <button
                                className="updateProfile"
                                style={{ padding: "1px 10px" }}
                                onClick={() => {
                                  handleTabClick(
                                    "Depot Activities",
                                    row,
                                    true
                                  );
                                  setToggle3();
                                }}
                              >
                                Activities
                              </button>
                              {StudyMode === "DBP Mode" &&
                                <>
                                  <button
                                    className="updateProfile"
                                    style={{ padding: "1px 10px" }}
                                    onClick={() => {
                                      setRowData(row);
                                      setToggle();
                                    }}
                                  >
                                    Edit
                                  </button>
                                  <button
                                    disabled={row?.totalKit > 0}
                                    className="removeProfile"
                                    style={{ padding: "1px 10px" }}
                                    onClick={() =>
                                      softDeleteRestoreStudyDepotRow(
                                        row?._id,
                                        "delete"
                                      )
                                    }
                                  >
                                    Delete
                                  </button>
                                </>
                              }
                            </div>
                          </Card.Footer>
                        </Card>
                      </Col>
                    );
                  })}
                </Row>
              </Container>

              <div className="position-sticky bottom-0 start-0">
                <Pagination
                  totalPage={totalPage}
                  pageNumber={pageNumber}
                  itemsPerPage={itemsPerPage}
                  totalItems={depotRowsCount}
                  setPageNumber={setPageNumber}
                  setItemsPerPage={setItemsPerPage}
                />
              </div>
            </>
          )}
        </>
      </SplitPane>
      {/* Manage Depot Order Offcanvas */}
      <ManageDepotOrder
        Show={!toggle6}
        Hide={setToggle6}
        Title="Manage Depot Order"
        getStudyDepotRowData={getStudyDepotRowData}
      />

      {/* Edit Depot Modal */}
      <UpdateDepot
        Show={!toggle}
        Hide={setToggle}
        rowData={rowData}
        setRowId={setRowId}
        depotColumns={depotColumns}
        countryList={countryList}
        getStudyDepotRowData={getStudyDepotRowData}
        Title={"Update Depot"}
      />

      {/* View Depot Modal */}
      <DepotDetail
        Show={!toggle7}
        Hide={setToggle7}
        rowData={rowData}
        depotColumns={depotColumns}
        Title={`View ${rowData?.row?.DEPOTNAME} Details`}
        eiwrsPermission={eiwrsPermission}
      />

      {/* Deleted Depot Modal */}
      <DeletedDepot
        Show={!toggle1}
        Hide={setToggle1}
        studyId={studyId}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        depotDeletedRows={depotDeletedRows}
        getDeletedStudyDepotRowData={getDeletedStudyDepotRowData}
        depotDeletedRowsCount={depotDeletedRowsCount}
        pageNumberDeleted={pageNumberDeleted}
        itemsPerPageDeleted={itemsPerPageDeleted}
        setPageNumberDeleted={setPageNumberDeleted}
        setItemsPerPageDeleted={setItemsPerPageDeleted}
        softDeleteRestoreStudyDepotRow={softDeleteRestoreStudyDepotRow}
        Title={"Deleted Depot History"}
      />

      {/* Depot Activities Offcanvas */}
      <Offcanvas
        show={!toggle3}
        onHide={setToggle3}
        placement="end"
        style={{ width: 900 }}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Depot Activities - {rowData?.row?.DEPOTNAME || rowData?.row?.DEPOTID || ""}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0">
          <DepotActivities
            onMouseDown={onMouseDown}
            tableRef={tableRef}
            depotActivity={depotActivity}
            activityLoader={activityLoader}
            getStudyAuditTrials={getStudyAuditTrials}
            rowData={rowData}
            depotActivityCount={depotActivityCount}
          />
        </Offcanvas.Body>
      </Offcanvas>

      {/* Updated History Offcanvas */}
      <Offcanvas
        show={!toggle4}
        onHide={setToggle4}
        placement="end"
        style={{ width: 900 }}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Updated History - {rowData?.row?.DEPOTNAME || rowData?.row?.DEPOTID || ""}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0">
          <DepotUpdatedHistory
            onMouseDown={onMouseDown}
            tableRef={tableRef}
            getStudyDepotAutitTrials={getStudyDepotAutitTrials}
            depotHistory={depotHistory}
            rowData={rowData}
            historyLoader={historyLoader}
          />
        </Offcanvas.Body>
      </Offcanvas>

      {/* Properties Offcanvas */}
      <Offcanvas
        show={!toggle5}
        onHide={setToggle5}
        placement="end"
        size="lg"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Properties - {rowData?.row?.DEPOTNAME || rowData?.row?.DEPOTID || ""}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0">
          <DepotProperties
            onMouseDown={onMouseDown}
            tableRef={tableRef}
            rowData={rowData}
          />
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default DepotDataList;